import { render, staticRenderFns } from "./Detaileddis.vue?vue&type=template&id=d09ee2e8"
import script from "./Detaileddis.vue?vue&type=script&lang=js"
export * from "./Detaileddis.vue?vue&type=script&lang=js"
import style0 from "./Detaileddis.vue?vue&type=style&index=0&id=d09ee2e8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports